const ReactDeclarativeHead = require('./lib/react-declarative-head');

module.exports = ReactDeclarativeHead;
exports = module.exports;
exports.Head = ReactDeclarativeHead;
